import db from "../driverappdb";

export const CustomerTypeRepository = {
    get: async (customerTypeId) => {
        return await db.customertypes.get(customerTypeId);
    }
};